import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    disableAnimations,
    marginTop,
    textColorToken,
    textColorTokenArgs,
    textStyleToken,
    textStyleTokenArgs
  } = _ref;
  return {
    wrapperStyle: _objectSpread({
      marginTop,
      transition: disableAnimations ? undefined : 'margin-top .5s',
      flexDirection: 'row'
    }, marginTop === 0 ? {
      alignItems: 'center'
    } : {}),
    labelFeedbackStateIconOuterWrapperStyle: _objectSpread(_objectSpread({}, platformSelect({
      ios: {
        marginTop: -1,
        marginBottom: -1
      },
      android: {
        marginTop: -1.75,
        marginBottom: -1.55
      },
      default: {
        marginTop: -2,
        marginBottom: -2
      }
    })), {}, {
      marginRight: 5
    }),
    labelFeedbackStateIconInnerWrapperStyle: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    textStyle: _objectSpread(_objectSpread({
      color: designContext.get(textColorToken, textColorTokenArgs).toString()
    }, designContext.get(textStyleToken, textStyleTokenArgs).styles()), {}, {
      overflow: 'hidden',
      textAlign: 'left'
    }, platformSelect({
      web: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        transition: disableAnimations ? undefined : 'font-size .5s'
      },
      default: {}
    }))
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map